export enum SampleType {
    default = 0,
    number = 1,
    date = 2,
    spreadsheet = 3,
    text = 4,
}
